var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"d-none d-lg-block flex-grow-1 navbar-tool-search-desktop"},[_c('SearchInput')],1)}
var staticRenderFns = []

export { render, staticRenderFns }